import WebApp from '@twa-dev/sdk'
import { createEffect } from 'effector'
import { onError } from '@/app/routing/events'

import { getCaseContent, getCases, getKeysBundles, postClaimDailyKey, postOpenCase, postPurchaseKey } from './api'
import { triggerKeysRefetch } from './events'

import { getUniqueContent } from './api'
import { OpenCaseFxDTO } from './types'

const getCaseListFx = createEffect(async ({ token }: { token: string }) => {
  const data = await getCases(token)
  return data
})
getCaseListFx.failData.watch(() => {
  onError()
})

const claimDailyKeyFx = createEffect(async (token: string) => {
  const data = await postClaimDailyKey(token)
  return data
})
claimDailyKeyFx.failData.watch(() => {
  onError()
})

type GetCaseContentDTO = {
  token: string
  id: number
}

const getCaseContentFx = createEffect(async (params: GetCaseContentDTO) => {
  const { token, id } = params
  const data = await getCaseContent(token, id)
  return data
})

getCaseContentFx.failData.watch(() => {
  onError()
})

type PurchaseKeyFxType = {
  token: string
  key_id: number
}

const purchaseKeyFx = createEffect(async (params: PurchaseKeyFxType) => {
  const { token, key_id } = params
  const data = await postPurchaseKey(token, key_id)
  return { invoiceUrl: data.invoice_url, token }
})

purchaseKeyFx.doneData.watch((data) => {
  WebApp.openInvoice(data.invoiceUrl, (status) => {
    if (status == 'paid') {
      triggerKeysRefetch(data.token)
    }
  })
})

triggerKeysRefetch.watch((token) => {
  getCaseListFx({ token })
})

purchaseKeyFx.failData.watch(() => {
  onError()
})

const openCaseFx = createEffect(async (params: OpenCaseFxDTO) => {
  const data = await postOpenCase(params)
  return data
})
openCaseFx.failData.watch(() => {
  onError()
})

export const videoHasBeenLoadedFx = createEffect(async () => {
  return {
    status: true,
  }
})

export const getUniqueContentFx = createEffect(async (params: { token: string; id: number }) => {
  const response = await getUniqueContent(params.token, params.id)
  return response
})

export const getShopItemsFx = createEffect(async (token: string) => {
  const response = await getKeysBundles(token)
  return response
})

export { getCaseListFx, claimDailyKeyFx, getCaseContentFx, purchaseKeyFx, openCaseFx }
